
<template>
  <div>
    <div>
      <div
        class="modal fade show"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        v-if="$store.state.userStore.trackAppModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                연동 정보
              </h5>
            </div>
            <div class="modal-body">
              <div>
                <div>
                  <div v-if="$store.state.userStore.trackOrApi == 0">
                    <h6 class="card-inside-title">트래킹 코드</h6>
                    <div class="input-group">
                      <span class="form-control">{{$store.state.userStore.trackingCode}}</span>
<!--                      <input-->
<!--                        type="number"-->
<!--                        class="form-control"-->
<!--                        value="{{$store.state.userStore.trackingCode}}"-->
<!--                        disabled-->
<!--                      />-->


                    </div>
                  </div>
                  <div v-if="$store.state.userStore.trackOrApi == 1">
                    <h6 class="card-inside-title">Api 키</h6>
                    <div class="input-group">
                      <span class="form-control">{{$store.state.userStore.apiKey}}</span>
<!--                      <input-->
<!--                          type="number"-->
<!--                          class="form-control"-->
<!--                          value="{{$store.state.userStore.apiKey}}"-->
<!--                          disabled-->
<!--                      />-->


                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" @click="closeModal">
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>




<script>




export default {
  // name: "auth",
  data() {
    return {
    };
  },

  methods: {

    closeModal() {
      this.$store.state.userStore.trackAppModal = false;
    },

  },
  mounted() {
    console.log("trackApiCode.mounted");
  },
  created() {
    console.log("trackApiCode. created");




  },
  beforeDestroy() {},
};
</script>
